import { Paper, IconButton, Typography, Alert, Stack, TextField } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

import { HeatPumpLoadProfileDto } from '../../pv-calculator.dto';

export default function HeatPumpLoad(props: {
    value: HeatPumpLoadProfileDto;
    onChange: (loadProfile: HeatPumpLoadProfileDto) => void;
    onDelete: () => void;
}) {
    const { t } = useTranslation();

    function onChange(updated: Partial<HeatPumpLoadProfileDto>) {
        props.onChange({
            ...props.value,
            ...updated,
        });
    }

    return (
        <Paper variant="outlined" sx={{ p: 2, position: 'relative' }}>
            <IconButton sx={{ position: 'absolute', top: 0, right: 0 }} onClick={() => props.onDelete()}>
                <Delete />
            </IconButton>

            <Stack spacing={2}>
                <Typography variant="h6">{t('Heat pump')}</Typography>
                <TextField
                    label={t('Annual heat demand (kWh)')}
                    type="number"
                    size="small"
                    value={props.value.annual_heat_demand}
                    onChange={(e) => onChange({ annual_heat_demand: parseFloat(e.target.value) })}
                    error={!(props.value.annual_heat_demand > 0)}
                    helperText={
                        !(props.value.annual_heat_demand > 0) && t('The annual heat demand has to be greater than 0.')
                    }
                    slotProps={{ htmlInput: { min: 0, step: 100 } }}
                />
                <TextField
                    label={t('Annual COP')}
                    type="number"
                    size="small"
                    value={props.value.annual_cop}
                    onChange={(e) => onChange({ annual_cop: parseFloat(e.target.value) })}
                    error={!(props.value.annual_cop > 0)}
                    helperText={!(props.value.annual_cop > 0) && t('The annual COP has to be greater than 0.')}
                    slotProps={{ htmlInput: { min: 0, step: 0.1 } }}
                />

                <Alert color="warning" sx={{ mt: 1 }}>
                    <Stack>
                        <Typography variant="body2">
                            {t(
                                'A specialized heat pump load profile is only available for the following building types:',
                            )}
                        </Typography>
                        <ul>
                            <li>KINDERGARTEN</li>
                        </ul>
                        <Typography variant="body2">
                            {t(
                                'For all other building types, the standard profile is used. Note that this is less accurate and might lead to misleading designs.',
                            )}
                        </Typography>
                    </Stack>
                </Alert>
            </Stack>
        </Paper>
    );
}
